const homepage = require("./pages/homepage")
const partner = require("./pages/partner")
const achievement = require("./pages/achievement")
const activity = require("./pages/activity")
const overview = require('./pages/overview');
const overviewMenu = require('./pages/overviewMenu');
const staff = require('./pages/staff');
const contact = require('./pages/contact');
const story = require('./pages/story');
const navSocial = require('./pages/nav-social');
const news = require('./pages/news');
const strategy = require('./pages/strategy');

$("document").ready(function () {
  homepage();
  overview();
  partner();
  achievement();
  activity();
  staff();
  contact();
  navSocial();
  story();
  news();
  strategy();
  if ($(".overview, .strategy, .staff, .achievement, .partner").length) {
    overviewMenu();
  }
  $('#toggle-menu').click(function(){
    $('#menu-content').animate({
      height: '100vh',
      maxHeight: '100vh',
      opacity: '1',
    },);

    $(this).animate({
      bottom: '0',
      opacity: '0'
    });

    $('#close-menu').animate({
      top: '31px',
      opacity: '1'
    });

    $('.menu-mobile .langue').animate({
      opacity: '1'
    });

    $('.menu-wrap').css("margin-left", 'calc(50% - 55px)');

  });

  $('#close-menu').click(function(){
      $(this).animate({
        top: '0',
        opacity: '0'
      });

      $('#menu-content').animate({
        height: '0',
        maxHeight: '0',
        opacity: '0',
      });


      $('#toggle-menu').animate({
        bottom: '50%',
        opacity: '1'
      });

      $('.menu-mobile .langue').animate({
        opacity: '0'
      });

      $('.menu-wrap').css("margin-left", '0');

  });
  
  $("#back-top").click(function () {
    $("html, body").animate({scrollTop: 0}, 1000);
  });
})

if ($(window).width() < 992) {
  $(window).scroll(function() {
    if ($(this).scrollTop()) {
        $('#back-top').fadeIn();
    } else {
        $('#back-top').fadeOut();
    }
  });
  
  $('.menu-toggle').click(function (){
    const isActive = $(this).hasClass("active");
    $(this).toggleClass("active");
    const $menuChild = $(this).parent().find('.menu-child');
    anime({
      targets: $menuChild[0],
      height: isActive ? 0 : 74,
      paddingTop: isActive ? 0 : 12,
      });
    $(this).css({
      "transform": `rotate(${isActive ? '0deg' : '180deg'})`,
      "top": `${isActive ? '4px' : '10px'}`
    })
  })
}

$(window).resize(function () {

})
